import { D38_21 } from "./D38_21"

export const D38_20 = {
    "selectedValueColumn": "AgentCustomerGroup",
    "selectedTitle": "Channel",
    "visual": [
        {
            "columns": 12,
            "rows": 2,
            "visual": {
                "id": 1,
                "type": "advancedTable",
                "colorTheme": 'colorTheme1',
                "title": "Channel Growth",
                "binding": {
                    "data": {
                        "columns": [
                            {
                                "name": 'Channel Code',
                                "columnName": 'DistributorCode',
                                "width": '170px',
                                "align": "left",
                                "sortable": true,
                                "sum": false,
                            },
                            {
                                "name": 'Channel Name',
                                "columnName": 'DistributorName',
                                "width": '300px',
                                "align": "left",
                                "sortable": true,
                                "sum": false,
                            },
                            {
                                "name": 'Actual Sales',
                                "columnName": 'ActualSales',
                                "width": '140px',
                                "align": "right",
                                "sortable": true,
                                "sum": true,
                            },
                            {
                                "name": 'LY Sales',
                                "columnName": 'LYSales',
                                "width": '125px',
                                "align": "right",
                                "sortable": true,
                                "sum": true,
                            },
                            {
                                "name": 'Growth %',
                                "columnName": 'Growth',
                                "width": '125px',
                                "align": "right",
                                "sortable": true,
                                "sum": false,
                                "percent": true
                            }
                        ],
                        "title": "TerritoryName",
                        "endpoint": "D38.20",
                        "parameters": [
                            { "key": "FromMonth", "value": "2024" },
                            { "key": "FromYear", "value": "1" },
                            { "key": "ToMonth", "value": "2024" },
                            { "key": "ToYear", "value": "1" },
                            { "key": "AgentCustomerGroup", "value": "" },
                            { "key": "ConfigTypeCode", "value": "" },
                            { "key": "DistrictManagerCode", "value": "" }
                        ]
                    },
                    "context": {
                        "point": {
                            "onClick": D38_21
                        }
                    }
                }
            }
        }
    ]
}